<mat-dialog-content>
  <div
    class="text-center dialog-head position-relative rounded p-t-20 p-x-8 p-b-12"
  >
    <!-- Clock SVG Icon -->
    <div class="m-b-24 d-flex justify-content-center">
      <img
        src="assets/images/svgs/session-timeout.svg"
        alt="Session Timeout"
        width="64"
        height="64"
      />
    </div>

    <!-- Title -->
    <h2 class="f-s-24 f-w-600 m-0 m-b-10">Session Timeout</h2>

    <!-- Message -->
    <p class="f-s-15 f-w-400 m-0 m-b-32 text-secondary">
      You’ve been inactive for a while. To keep your account safe, we’ll log you
      out in <strong style="font-weight: 700">{{ countdown }}s</strong> unless
      you choose to stay signed in.
    </p>

    <!-- Buttons -->
    <div class="d-flex gap-16 justify-content-center">
      <button
        mat-flat-button
        color="secondary"
        mat-dialog-close
        class="w-50 m-r-5"
        (click)="onLogout()"
      >
        Log Off Now
      </button>
      <button
        mat-flat-button
        color="primary"
        class="w-50 m-l-5"
        (click)="stayLoggedIn()"
      >
        Stay Signed In
      </button>
    </div>
  </div>
</mat-dialog-content>
